import React from 'react';
import ReactDOM from 'react-dom/client';
import CharacterGenerator from './CharacterGenerator';
import './index.css';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <CharacterGenerator />
  </React.StrictMode>
);